import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';

const QualitySettings = ({ quality, onQualityChange }) => {
  const { t } = useTranslation();
  
  const qualityOptions = [
    {
      value: 'standard',
      label: t('pdfUpload.quality.standard.label'),
      description: t('pdfUpload.quality.standard.description'),
      icon: 'Gauge',
      resolution: t('pdfUpload.quality.standard.resolution'),
      compression: t('pdfUpload.quality.standard.compression')
    },
    {
      value: 'high',
      label: t('pdfUpload.quality.high.label'),
      description: t('pdfUpload.quality.high.description'),
      icon: 'Sparkles',
      resolution: t('pdfUpload.quality.high.resolution'),
      compression: t('pdfUpload.quality.high.compression')
    }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-elevation-sm">
      <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
        <Icon name="Settings" size={20} className="text-accent" />
        {t('pdfUpload.quality.title')}
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {qualityOptions?.map((option) => (
          <button
            key={option?.value}
            onClick={() => onQualityChange(option?.value)}
            className={`
              relative p-4 rounded-lg border-2 text-left transition-all duration-250
              ${quality === option?.value
                ? 'border-accent bg-accent/5' :'border-border bg-card hover:border-accent/50 hover:bg-accent/5'
              }
            `}
          >
            <div className="flex items-start gap-3">
              <div className={`
                w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0
                ${quality === option?.value ? 'bg-accent/20' : 'bg-muted'}
              `}>
                <Icon
                  name={option?.icon}
                  size={20}
                  className={quality === option?.value ? 'text-accent' : 'text-muted-foreground'}
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h4 className="text-sm font-semibold text-foreground">{option?.label}</h4>
                  {quality === option?.value && (
                    <div className="w-5 h-5 rounded-full bg-accent flex items-center justify-center">
                      <Icon name="Check" size={12} className="text-accent-foreground" />
                    </div>
                  )}
                </div>
                <p className="text-xs text-muted-foreground mb-3">{option?.description}</p>
                <div className="flex flex-wrap gap-2">
                  <span className="inline-flex items-center gap-1 px-2 py-1 bg-muted rounded text-xs text-muted-foreground">
                    <Icon name="Maximize2" size={12} />
                    {option?.resolution}
                  </span>
                  <span className="inline-flex items-center gap-1 px-2 py-1 bg-muted rounded text-xs text-muted-foreground">
                    <Icon name="Zap" size={12} />
                    {option?.compression}
                  </span>
                </div>
              </div>
            </div>
          </button>
        ))}
      </div>

      <div className="mt-4 p-3 bg-muted/50 rounded-lg flex items-start gap-2">
        <Icon name="Info" size={16} className="text-muted-foreground mt-0.5" />
        <p className="text-xs text-muted-foreground">
          {t('pdfUpload.quality.info')}
        </p>
      </div>
    </div>
  );
};

export default QualitySettings;